import { AUTH_TOKEN_NAME, ADMIN_TOKEN_NAME, TASK_TOKEN_NAME } from '../constants';

const TOKEN_MAP = {
  admin: ADMIN_TOKEN_NAME,
  breezeway: AUTH_TOKEN_NAME,
  task: TASK_TOKEN_NAME,
};

const storage = localStorage || window.localStorage;

export const setAuthToken = (token, config = 'breezeway') =>
  storage && storage.setItem(TOKEN_MAP[config], token);

export const getAuthToken = (config = 'breezeway') => storage && storage.getItem(TOKEN_MAP[config]);

export const removeAuthToken = (config = 'breezeway') =>
  storage && storage.removeItem(TOKEN_MAP[config]);
